export const COLUMNS = [
  { id: 'name', label: 'Заголовок', width: '60%' },
  { id: 'code', label: 'Дата', width: '15%' },
  {
    id: 'population',
    label: 'Действия',
    width: '25%',
  },
];
